import React from "react";
import userContext from '../../../userContext'

export default function HomeDetailsv2(props) {
    const context = React.useContext(userContext)
    const burl = context.getBurl()

    let actualHome = props.sel.property
    let homeData = props.data

    if (homeData && homeData.properties.map((property) => property.name).includes(actualHome)) {
        const home = homeData.properties.find((property) => property.name === actualHome);
        let list = JSON.parse(home.homeViewNew)
        if (typeof list === "string") {
            list = JSON.parse(list)
        }

        return (
            <div className="home-details-v2">
                    {Array.isArray(list) && list.map((item, indexCategory) => {
                        const images = item.images?.map((image) => {
                            return burl + "/uploads/" + image
                        })

                        return (
                        <div className="hd-section" key={indexCategory}>
                            <div className="hd-section__header">
                                <h3>{item.title}</h3>
                                    </div>

                            {item.content?.map((contentItem, indexSection) => (
                                <div className="hd-category" key={indexSection}>
                                    <h4 className="hd-category__title">{contentItem.title}</h4>

                                    {contentItem.type === "text" ? (
                                        contentItem.fields?.map((field, indexSingle) => {
                                            let fieldValue = field.value
                                                    if (field.type === "check") {
                                                fieldValue = field.value === 'true' || field.value === true
                                            }

                                                    return (
                                                <div className="hd-field" key={indexSingle}>
                                                    <span className="hd-field__label">{field.title}</span>
                                                    <div className="hd-field__value">
                                                        {field.type === "input" || field.type === "textarea" ? (
                                                            <p>{field.value || '-'}</p>
                                                                ) : field.type === "check" ? (
                                                            <span className={`hd-checkbox ${fieldValue ? 'hd-checkbox--checked' : ''}`}>
                                                                {fieldValue ? '✓' : '✗'}
                                                            </span>
                                                                ) : (
                                                            <p>{field.value || '-'}</p>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            ) : (
                                        <div className="hd-field">
                                            <span className="hd-field__label">Activé</span>
                                            <div className="hd-field__value">
                                                <span className={`hd-checkbox ${contentItem.value ? 'hd-checkbox--checked' : ''}`}>
                                                    {contentItem.value ? '✓' : '✗'}
                                                </span>
                                            </div>
                                            {contentItem.value && contentItem.fields?.map((field, indexSingle) => (
                                                <div className="hd-field hd-field--nested" key={indexSingle}>
                                                    <span className="hd-field__label">{field.title}</span>
                                                    <div className="hd-field__value">
                                                        {field.type === "input" || field.type === "textarea" ? (
                                                            <p>{field.value || '-'}</p>
                                                                        ) : field.type === "check" ? (
                                                            <span className={`hd-checkbox ${field.value ? 'hd-checkbox--checked' : ''}`}>
                                                                {field.value ? '✓' : '✗'}
                                                            </span>
                                                        ) : (
                                                            <p>{field.value || '-'}</p>
                                                                        )}
                                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            ))}

                            {images && images.length > 0 && (
                                <div className="hd-images">
                                    <h4 className="hd-category__title">Photos</h4>
                                    <div className="hd-images__grid">
                                        {images.map((url, index) => (
                                            <img key={index} src={url} alt={`Photo ${index + 1}`} className="hd-images__item" />
                                        ))}
                                    </div>
                                </div>
                            )}
                            </div>
                        )
                    })}
            </div>
        )
    }

        return (
        <div className="home-details-v2">
            <div className="hd-error">
                <p>Aucune information disponible pour cette propriété.</p>
            </div>
        </div>
        )
    }
